enum EBasicActions {
  Get = 'get', 
  Find = 'find', 
  Create = 'create', 
  Edit = 'edit', 
  Delete ='delete'
}

export default EBasicActions;
